module.exports = __webpack_public_path__ + "static/media/small-plus.16124489.svg";